/* Timbrica — /wind-map (live global wind, animated particles).
 *
 * GFS 10 m wind (decoded server-side from GRIB2) streamed as animated particles
 * via leaflet-velocity (MIT). Data comes only from our same-origin /api/wind/grid
 * proxy (RU-safe). Forecast steps (now / +1-3 days) + a units toggle. "Read"
 * (tap/near-me) shows speed + direction + Beaufort from the grid.
 * Honest: GFS is a forecast model refreshed 4x/day — not second-by-second.
 */
(function () {
  'use strict';
  var C = window.WIND_CFG || {};
  var T = C.t || {}, API = C.api || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };

  var map = null, vLayer = null, gridU = null, gridV = null;
  var fh = 0, unit = 'ms', lastData = null, lastPt = null, completed = false, loading = false;

  // ── units ──────────────────────────────────────────────────────────────────
  var UNITS = { ms: { f: 1, d: 0, k: 'u_ms', lv: 'm/s' }, kmh: { f: 3.6, d: 0, k: 'u_kmh', lv: 'k/h' }, kn: { f: 1.94384, d: 0, k: 'u_kn', lv: 'kt' }, bft: { f: 1, d: 0, k: 'u_bft', lv: 'm/s' } };
  function beaufort(ms) { var b = [0.3, 1.6, 3.4, 5.5, 8, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7]; for (var i = 0; i < b.length; i++) if (ms < b[i]) return i; return 12; }
  function fmtSpeed(ms) { if (unit === 'bft') return String(beaufort(ms)); var u = UNITS[unit]; return (ms * u.f).toFixed(u.d); }
  function unitLabel() { return tr(UNITS[unit].k); }

  function initMap() {
    if (!window.L || !$('wnMap')) return;
    var tile = C.tile || {};
    map = L.map('wnMap', { center: [C.home.lat, C.home.lon], zoom: C.home.z, minZoom: 1, maxZoom: 8, worldCopyJump: true });
    // Подложка через общий примитив: второй адрес (наш прокси <-> прямой CDN)
    // и честная строка, если не ответил ни один. Здесь стоял пустой
    // .on('tileerror', function () {}) — крючок был, внутри ничего, и
    // упавший хост давал ЧЁРНЫЙ прямоугольник без слова объяснения.
    if (window.__mapTiles) {
      window.__mapTiles.base(L, map, null, {
        slug: 'wind-map', credit: tr('map_attr'), opts: { maxZoom: 19 }, text: tile.offline,
        styles: tile.styles, labels: tile.labels,
        onStyle: function (mode) {
          skin = SCALE[mode] ? mode : 'dark';
          var st = document.querySelector('.wn-stage');
          if (st) st.setAttribute('data-basemap', mode);
          if (typeof renderLayer === 'function') renderLayer();
        }
      });
    } else if (window.__basemapFallback) {
      window.__basemapFallback(L, map, tr('map_attr'));
    }
    map.on('click', function (ev) { readWind(ev.latlng.lat, ev.latlng.lng); });
  }

  function spinner(on) { var ld = $('wnLoading'); if (ld) ld.classList.toggle('hidden', !on); }
  function fcDisabled(on) { document.querySelectorAll('.wn-fc button').forEach(function (b) { b.disabled = on; }); }

  /* Две шкалы скорости. Spectral сделана под тёмный фон: её светлый край
     (#e6f598, #abdda4, #fee08b) — это почти белый, и на positron (#fafaf8)
     самые частые, СЛАБЫЕ ветра исчезают первыми, то есть карта врёт именно
     там, где данных больше всего. Светлая шкала повторяет тот же порядок
     «холодное → тёплое», но целиком в тёмной половине яркости. */
  var SCALE = {
    dark:  ['#3288bd', '#66c2a5', '#abdda4', '#e6f598', '#fee08b', '#fdae61', '#f46d43', '#d53e4f'],
    light: ['#1a4f8a', '#1b7a68', '#3d7a2a', '#7a6a10', '#b07a00', '#c2610a', '#c0392b', '#8e1b2a']
  };
  var skin = 'dark';
  function renderLayer() {
    if (!lastData) return;
    if (vLayer) { map.removeLayer(vLayer); vLayer = null; }
    vLayer = L.velocityLayer({
      displayValues: true,
      displayOptions: { velocityType: '', position: 'bottomleft', emptyString: tr('no_data'), angleConvention: 'bearingCW', speedUnit: UNITS[unit].lv, directionString: tr('direction'), speedString: tr('speed') },
      data: lastData,
      velocityScale: 0.012,
      maxVelocity: 25,
      /* На светлой подложке шлейф частицы гаснет В СТОРОНУ ФОНА, то есть к
         почти белому, — и слабеет ровно то, чем тул отвечает. Замер 23.08:
         уверенно читаемых пикселей 2523 на тёмной против 111 на светлой при
         одной и той же ширине линии. Поэтому там линия толще, шлейф живёт
         дольше и рисуется плотнее: 111 → счёт возвращается в тот же порядок. */
      lineWidth: skin === 'light' ? 2.4 : 1,
      particleAge: skin === 'light' ? 120 : 90,
      opacity: skin === 'light' ? 0.99 : 0.97,
      colorScale: SCALE[skin]
    });
    vLayer.addTo(map);
  }

  function load(hr, isAuto) {
    if (loading) return;
    loading = true;
    var first = !completed;
    if (!isAuto) {
      if (first) spinner(true);
      else { var st = $('wnStatus'); if (st) st.textContent = tr('loading'); fcDisabled(true); } // keep map visible on a forecast switch
    }
    var t0 = Date.now();
    fetch(API.grid + '?h=' + hr).then(function (r) { return r.json(); }).then(function (d) {
      loading = false; fcDisabled(false);
      if (!d || !d.data || d.err) { fail(); return; }
      fh = (d.fh != null ? d.fh : hr);
      lastData = d.data; gridU = d.data[0]; gridV = d.data[1];
      renderLayer();
      spinner(false);
      $('wnDot').classList.toggle('stale', !!d.stale);
      $('wnStatus').textContent = (fh > 0 ? tr('valid_at') : tr('updated')) + ' ' + fmtTime(d.valid || cycleIso(d.cycle)) + (d.stale ? ' · ' + tr('stale') : '');
      if (lastPt) readWind(lastPt[0], lastPt[1]); // refresh open reading for the new step
      if (!completed) { completed = true; ae('tool_complete', { slug: 'wind-map', ms: Date.now() - t0, stale: !!d.stale }); }
    }).catch(function () { loading = false; fcDisabled(false); fail(); });
  }
  function fail() {
    loading = false; fcDisabled(false);
    if (!completed) { // only blank the map if we never had data; a failed forecast switch keeps the current wind
      var ld = $('wnLoading');
      if (ld) { var s = ld.querySelector('span'); if (s) s.textContent = tr('no_data'); var sp = ld.querySelector('.wn-spinner'); if (sp) sp.style.display = 'none'; ld.classList.remove('hidden'); }
    } else { var st = $('wnStatus'); if (st) st.textContent = tr('no_data'); }
    ae('tool_error', { slug: 'wind-map', where: 'grid', error_type: 'data_unavailable' });
  }

  function cycleIso(c) { if (!c || c.length < 10) return ''; return c.slice(0, 4) + '-' + c.slice(4, 6) + '-' + c.slice(6, 8) + 'T' + c.slice(8, 10) + ':00:00Z'; }
  function fmtTime(iso) { var t = Date.parse(iso); if (isNaN(t)) return ''; try { return new Date(t).toLocaleString(C.locale, { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }); } catch (e) { return iso; } }

  function gridVal(g, lat, lon) {
    var h = g.header, lo = ((lon % 360) + 360) % 360;
    var col = Math.round(lo / h.dx) % h.nx, row = Math.round((h.la1 - lat) / h.dy);
    if (row < 0) row = 0; if (row > h.ny - 1) row = h.ny - 1;
    return g.data[row * h.nx + col];
  }
  function compass(deg) { var c = tr('compass').split(','); return c[Math.round(deg / 45) % 8]; }

  // Подпись точки — общий модуль GeoCity (public/js/geo-city.js): город на
  // языке страницы, румб и расстояние («↗ Город · 42 км»).
  function geoFill(lat, lon, elId, ok) {
    if (!window.GeoCity) return;
    GeoCity.fill(elId, lat, lon, { empty: '—', ok: ok });
  }

  function readWind(lat, lon) {
    if (!gridU || !gridV) return;
    lastPt = [lat, lon];
    var u = gridVal(gridU, lat, lon), v = gridVal(gridV, lat, lon);
    var spd = Math.sqrt(u * u + v * v);
    var dir = (Math.atan2(-u, -v) * 180 / Math.PI + 360) % 360; // meteorological: FROM
    var sub = unit === 'bft' ? '' : '<div class="wn-pop-bft">' + tr('bft') + ' ' + beaufort(spd) + '</div>';
    L.popup({ className: 'wn-pop' }).setLatLng([lat, lon]).setContent(
      '<div class="wn-pop-spd">' + fmtSpeed(spd) + ' <small>' + unitLabel() + '</small></div>' +
      '<div class="wn-pop-dir">' + tr('from') + ' ' + compass(dir) + ' (' + Math.round(dir) + '°)</div>' + sub +
      '<div id="wnGeo" style="font-size:12px;opacity:.72;margin-top:5px"></div>'
    ).openOn(map);
    geoFill(lat, lon, 'wnGeo', function () { return lastPt && lastPt[0] === lat && lastPt[1] === lon; });
    ae('feature_use', { slug: 'wind-map', feature: 'read' });
  }

  function setUnit(u) {
    if (u === unit || !UNITS[u]) return;
    unit = u;
    document.querySelectorAll('.wn-units button').forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-u') === u); });
    var lg = $('wnLegendUnit'); if (lg) lg.textContent = unitLabel();
    renderLayer();
    if (lastPt) readWind(lastPt[0], lastPt[1]);
    ae('feature_use', { slug: 'wind-map', feature: 'units', unit: u });
  }
  function setForecast(hr) {
    if (hr === fh || loading) return;
    document.querySelectorAll('.wn-fc button').forEach(function (b) { b.classList.toggle('active', +b.getAttribute('data-h') === hr); });
    load(hr, false);
    ae('feature_use', { slug: 'wind-map', feature: 'forecast', h: hr });
  }

  function locate() {
    // A bare `return` here was a literally silent dead click: the button
    // did nothing and said nothing. __geo.notify explains why and reports it.
    if (!navigator.geolocation) { if (window.__geo) __geo.notify('no_api'); return; }
    var b = $('wnLocate'); if (b) b.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) { map.setView([pos.coords.latitude, pos.coords.longitude], 5); readWind(pos.coords.latitude, pos.coords.longitude); if (b) b.disabled = false; ae('feature_use', { slug: 'wind-map', feature: 'locate' }); },
      function (err) { if (b) b.disabled = false; if (window.__geo) __geo.notify(err); }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
  }

  /* ── Leaflet and the wind plugin: both may come late ──────────────────────
   * When the own copy of Leaflet does not answer, the layout's fallback ladder
   * brings the mirror's copy AFTER this script ran (the mirror's address has an
   * «@», so the copy is not written in place but appended). Measured on the dev
   * stand with the own copy refused: Leaflet is on the page a moment later, but
   * the boot had already given up with a bare «⚠», and the plugin — then a tag
   * right after Leaflet's — had thrown «Cannot read properties of undefined
   * (reading 'DomUtil')» (Sentry TIMBRICA-FRONTEND-NZ). So: wait for Leaflet,
   * run the plugin only then, and say in words when neither came. */
  function leafletReady() {
    if (window.L && window.L.map) return Promise.resolve();
    if (window.__whenGlobal) return window.__whenGlobal('L', 15000);
    return Promise.reject(new Error('L'));
  }
  function velocityReady() {
    if (window.L.velocityLayer) return Promise.resolve();
    var urls = ((C.lib && C.lib.velocity) || []).slice();
    var nonced = document.querySelector('script[nonce]');
    return new Promise(function (resolve, reject) {
      (function next() {
        if (!urls.length) { reject(new Error('velocity')); return; }
        var s = document.createElement('script');
        s.src = urls.shift();
        if (nonced && nonced.nonce) s.nonce = nonced.nonce;
        s.onload = function () { if (window.L.velocityLayer) resolve(); else next(); };
        s.onerror = next;
        document.head.appendChild(s);
      })();
    });
  }
  function libFailed() {
    var ld = $('wnLoading');
    if (ld) {
      var s = ld.querySelector('span'); if (s) s.textContent = (C.lib && C.lib.failed) || '⚠';
      var sp = ld.querySelector('.wn-spinner'); if (sp) sp.style.display = 'none';
    }
    ae('tool_error', { slug: 'wind-map', where: 'lib', error_type: 'lib_fail', leaflet: window.L ? 1 : 0 });
    // The ladder's last copy may still arrive: then the map comes up after all.
    var late = function () {
      if (map || !(window.L && window.L.map)) return;
      document.removeEventListener('timbrica:script-recovered', late);
      velocityReady().then(start, function () {});
    };
    document.addEventListener('timbrica:script-recovered', late);
    window.addEventListener('load', late);
  }

  function boot() {
    try { window.Timbrica3D && window.Timbrica3D.init && window.Timbrica3D.init('wind-map'); } catch (e) {}
    leafletReady().then(velocityReady).then(start, libFailed);
  }

  function start() {
    if (map) return;
    var ld = $('wnLoading');
    if (ld) {
      var s = ld.querySelector('span'); if (s) s.textContent = tr('loading');
      var sp = ld.querySelector('.wn-spinner'); if (sp) sp.style.display = '';
    }
    initMap(); load(0, false);
    var lb = $('wnLocate'); if (lb) lb.addEventListener('click', locate);
    document.querySelectorAll('.wn-units button').forEach(function (b) { b.addEventListener('click', function () { setUnit(b.getAttribute('data-u')); }); });
    document.querySelectorAll('.wn-fc button').forEach(function (b) { b.addEventListener('click', function () { setForecast(+b.getAttribute('data-h')); }); });
    setInterval(function () { if (fh === 0 && !loading) load(0, true); }, 1800000); // refresh the analysis every 30 min
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
